import { gql } from "@apollo/client";

export const GET_OPTIONS_TALENT = gql`
    query {
        options: getOptionsTalent {
            preferences {
                name
                id
                order
                children {
                    name
                    description
                    order
                    id
                }
            }
            degree {
                name
                id
                children {
                    name
                    id
                }
            }
            degreeOptions {
                name
                id
                children {
                    name
                    id
                }
            }
            experiences {
                name
                id
                children {
                    name
                    id
                }
            }
            places {
                name
                id
                children {
                    name
                    id
                }
            }
            durations {
                name
                id
                children {
                    name
                    id
                }
            }
            advantages {
                name
                id
                children {
                    name
                    id
                    icon
                }
            }
            softSkills {
                name
                id
                children {
                    name
                    id
                }
            }
            diplomaScore {
                name
                id
                children {
                    name
                    id
                }
            }
            contractStatues {
                name
                id
                children {
                    name
                    id
                }
            }
            benefits {
                name
                id
                children {
                    name
                    id
                }
            }
            commissions {
                name
                id
                children {
                    name
                    id
                }
            }
            bonuses {
                name
                id
                children {
                    name
                    id
                }
            }
            groupProfessions {
                name
                id
                children {
                    name
                    id
                }
            }
            recruitmentMethods {
                name
                id
                children {
                    name
                    id
                }
            }
            sectors {
                name
                id
                children {
                    name
                    id
                }
            }
            majors {
                name
                id
                children {
                    name
                    id
                }
            }
            specialties {
                name
                id
                children {
                    name
                    id
                }
            }
            minHourlyRate
        }
    }
`;
